import { render } from "./GiftWithdraw.vue?vue&type=template&id=963c3db6&scoped=true"
import script from "./GiftWithdraw.vue?vue&type=script&lang=js"
export * from "./GiftWithdraw.vue?vue&type=script&lang=js"

import "./GiftWithdraw.vue?vue&type=style&index=0&id=963c3db6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963c3db6"]])

export default __exports__